import React, { useEffect, useState } from 'react';
import { clsx } from 'clsx';
import { centsToInput, maskMoney } from '@/utils/money';

interface MoneyInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> {
  /** Valor em centavos (contrato do backend). */
  value: number | null;
  onChange: (cents: number | null) => void;
  /** Símbolo à esquerda (padrão "R$"; ex.: "US$" para valor em moeda original). */
  prefix?: string;
}

/** Campo de dinheiro em R$ com máscara pt-BR; o valor trafega em centavos. */
export const MoneyInput: React.FC<MoneyInputProps> = ({ value, onChange, className, prefix = 'R$', ...rest }) => {
  const [display, setDisplay] = useState(() => centsToInput(value));

  useEffect(() => {
    setDisplay((d) => (maskMoney(d).cents === value ? d : centsToInput(value)));
  }, [value]);

  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-400 pointer-events-none">{prefix}</span>
      <input
        {...rest}
        type="text"
        inputMode="numeric"
        autoComplete="off"
        className={clsx('input-field text-right tabular-nums', prefix.length > 2 ? 'pl-12' : 'pl-9', className)}
        value={display}
        placeholder="0,00"
        onChange={(e) => {
          const { display: next, cents } = maskMoney(e.target.value);
          setDisplay(next);
          onChange(cents);
        }}
      />
    </div>
  );
};

export default MoneyInput;
